<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <b-row>
      <b-col lg="2">
        <div>
          <div  class="form-inline mb-2">
            <input
              type="radio"
              v-model="proxyVal"
              value="PROXY"
              :disabled="activeClaim && activeClaim.claimStatus != 3"
              @click="proxySelected('PROXY')"
            />
            <!-- :disabled="proxyDisableCheck()" -->
            <label class="ml-1">Proxy</label>

            <input
              type="radio"
              v-model="proxyVal"
              value="NON_PROXY"
              :disabled="activeClaim && activeClaim.claimStatus != 3"
              @click="proxySelected('NON_PROXY')"
              class="ml-3"
            />
            <!-- :disabled="proxyDisableCheck()" -->
                          <!-- @click="proxySelected('NON_PROXY')" -->
            <label class="ml-1">Non-Proxy</label>
          </div>

          <b-button
            block
            :disabled="
              !claim_id ||
              (activeClaim && activeClaim.claimStatus != 3) ||
              !proxyVal ||
              !checkIfClaimHasPermission(activeClaim)
            "
            variant="outline-primary"
            @click="costScheduleView"
          >
            <i class="fa-solid fa-chart-column"></i>
            Cost Schedule
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </b-button>
          <label class="label label-size text-muted">{{ cs_upadte_str }}</label>

          <div class="d-flex pt-4">
            <h4>
              Industry Choice -
              <span class="industry-str">{{ getIndustryTypeStr() }}</span>
            </h4>
          </div>

          <v-select
            class="vue-select pt-3 pb-3"
            placeholder="Select Industry"
            :options="industryTypeOptions"
            v-model="industryType"
            :clearable="false"
            :reduce="(option) => option.code"
            v-on:input="changeIndustry"
            :disabled="activeClaim && activeClaim.claimStatus != 3"
          ></v-select>
          <!-- :disabled="industryTypeDisableCheck()" -->

          <div class="mt-3 mb-4">
            <b-button
              block
              variant="outline-primary"
              @click="technicalReportView"
              :disabled="
                !claim_id ||
                (activeClaim && activeClaim.claimStatus != 3) ||
                !checkIfClaimHasPermission(activeClaim) ||
                (activeClaim && !activeClaim.industryType)
              "
            >
              <i class="fa-solid fa-screwdriver-wrench"></i>
              Technical Report
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </b-button>
            <label class="label label-size text-muted">{{
              tr_upadte_str
            }}</label>
          </div>

          <div class="pt-10">
          </div>
        </div>
      </b-col>
      <b-col lg="5">
        <b-card>
          <b-row align-v="center" class="notification-color">
            <b-col cols="8">
              <h3 class="mb-0 text-white">Notifications</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable
                ref="vuetableClientNotification"
                :api-mode="false"
                :fields="fields"
                :per-page="perPage"
                :data-manager="dataManagerClientNotification"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationDataNotification"
              >
                <template slot="custom-description" scope="props">
                  <span v-html="truncateText(props.rowData.description)"></span>
                  <a
                    v-if="props.rowData.description.length > 60"
                    @click="setActiveDescriotion(props.rowData.description)"
                    class="a-style"
                    v-b-modal.modal-notification
                  >
                    View More</a
                  >
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12" class="pt-2">
              <vuetable-pagination-info
                ref="paginationInfoNotification"
              ></vuetable-pagination-info>
              <vuetable-pagination
                class="float-right"
                ref="paginationNotification"
                @vuetable-pagination:change-page="
                  onChangePageClientNotification
                "
              ></vuetable-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="5">
        <b-card>
          <b-row align-v="center" class="checklist-color">
            <b-col cols="8">
              <h3 class="mb-0 text-white">Checklist for Clients</h3>
            </b-col>
            <b-col cols="4" class="text-right">
              <b-button
                id="show-btn"
                @click="
                  $bvModal.show('bv-modal-1');
                  loadCheckListInitial();
                "
                class="btn btn-sm btn-white"
                :disabled="
                  editCheckListDisableCondition ||
                  !checkIfClaimHasPermission(this.activeClaim)
                "
              >
                <i class="fa-regular fa-pen-to-square"></i>
                Edit List</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable
                ref="vuetableClientChecklist"
                :api-mode="false"
                :fields="checklistoptionfields"
                :per-page="perPage"
                :data-manager="dataManagerClientCheckList"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationDataClientCheckList"
              >
                <template slot="custom-actions" scope="props">
                  <b-form-checkbox
                    size="lg"
                    v-model="props.rowData.isUploaded"
                    name="check-button"
                    @input="
                      rejectClaimDocumentByAnalyst(
                        props.rowData.id,
                        props.rowData.isUploaded
                      )
                    "
                    :disabled="!props.rowData.isUploaded"
                    switch
                  >
                  </b-form-checkbox>
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12" class="pt-2">
              <vuetable-pagination-info
                ref="paginationClientInfoCheckList"
              ></vuetable-pagination-info>
              <vuetable-pagination
                class="float-right"
                ref="paginationClientCheckList"
                @vuetable-pagination:change-page="onChangePageClientCheckList"
              ></vuetable-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- Approve details display here.. -->
      <!-- <b-col lg="5">
            <b-card>
                <b-row align-v="center" slot="header">
                    <b-col cols="8">
                        <h3 class="mb-0">Claim as Approved </h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                       <p>Claim numbers as approved summery here - Content TBD</p>
                    </b-col>
                </b-row>
            </b-card>
        </b-col> -->
    </b-row>

    <!-- Start Checklist Model -->
    <b-modal id="bv-modal-1" hide-footer>
      <template #modal-title>
        <h3>Check List for Client</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <vuetable
              ref="vuetableChecklist"
              :api-mode="false"
              :fields="checklistfields"
              :per-page="perPage"
              :data-manager="dataManagerChecklist"
              pagination-path="pagination"
              @vuetable:pagination-data="onPaginationDataCheckList"
            >
              <template slot="custom-actions" scope="props">
                <b-form-checkbox-group
                  id="checkbox-group-2"
                  v-model="selectedCheckList"
                  name="flavour-2"
                >
                  <b-form-checkbox
                    class="ml-4"
                    :value="props.rowData.id"
                    size="lg"
                  ></b-form-checkbox>
                </b-form-checkbox-group>
              </template>
            </vuetable>
          </b-col>
          <b-col cols="12" class="pt-2">
            <vuetable-pagination-info
              ref="paginationInfoCheckList"
            ></vuetable-pagination-info>
            <vuetable-pagination
              class="float-right"
              ref="paginationCheckList"
              @vuetable-pagination:change-page="onChangePageCheckList"
            ></vuetable-pagination>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-3">
        <b-button
        
          variant="primary"
          @click="addClaimDocuments()"
          >Save</b-button
        >
        <!-- :disabled="!selectedCheckList.length || isLoading" -->
        <b-button variant="" @click="$bvModal.hide('bv-modal-1')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End Checklist Model -->

    <!-- Start Notification Modal -->
    <b-modal id="modal-notification" hide-footer>
      <template #modal-title>
        <h3>Notification</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <p v-html="activeNotification"></p>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-5">
        <b-button variant="" @click="$bvModal.hide('modal-notification')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
    <!-- End Notification Modal -->

    <!-- Start Report Link Modal -->
    <b-modal size="sm" id="modal-cost-schedule" hide-footer>
      <template #modal-title>
        <h3>Cost Schedule</h3>
      </template>
      <div class="text-center">
        <span class="custom-non-br-undeline">
          <b-button variant="primary" target="_blank" :href="costScheduleLink"
            >Click here to download the Cost Schedule</b-button
          >
        </span>
      </div>
      <div class="float-right mt-5"></div>
    </b-modal>
    <!-- End Report Link Modal -->

    <!-- Start Report Link Modal -->
    <b-modal size="sm" id="modal-technical-report" hide-footer>
      <template #modal-title>
        <h3>Technical Report</h3>
      </template>
      <div class="text-center">
        <span class="custom-non-br-undeline">
          <b-button
            variant="primary"
            target="_blank"
            :href="technicalReportLink"
            >Click here to download the Technical Report</b-button
          >
        </span>
      </div>
      <div class="float-right mt-5"></div>
    </b-modal>
    <!-- End Report Link Modal -->

    <!-- Start Report Link Modal -->
    <b-modal size="sm" id="modal-explore-file" hide-footer>
      <template #modal-title>
        <h3>Explore File</h3>
      </template>
      <div class="text-center">
        <span class="custom-non-br-undeline">
          <b-button variant="primary" target="_blank" :href="exploreFileLink"
            >Click here to explore file</b-button
          >
        </span>
      </div>
      <div class="float-right mt-5"></div>
    </b-modal>
    <!-- End Report Link Modal -->

    <!-- Email Confirmation Modal -->
    <b-modal
      centered
      :close-on-esc="false"
      :show-close="false"
      no-close-on-backdrop
      size="sm"
      id="email-send-confirmation"
      hide-footer
      hide-header
    >
      <b-row>
        <b-col cols="12">
          <div class="text-center mb-4">You're about to send an email to:</div>
          <div class="text-center mb-3 text-wrap-div">
            {{ emailString }}
          </div>
          <div class="text-center">
            <b-button
              variant="success"
              size="sm"
              class="pr-3 pl-3"
              @click="sendDocumentEmail()"
              >Send</b-button
            >
            <b-button
              variant="warning"
              size="sm"
              class="pr-3 pl-3"
              @click="closeEmailConfirmBox()"
              >Cancel</b-button
            >
          </div>
          <div class="float-right mt-5"></div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- End Email Confirmation Modal -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import NotificationDef from "./NotificationDef.js";
import ChecklistDef from "./ChecklistDef.js";
import ChecklistOptionDef from "./ChecklistOptionDef.js";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  mixins: [mixins],
  data() {
    return {
      fields: NotificationDef,
      checklistfields: ChecklistDef,
      checklistoptionfields: ChecklistOptionDef,
      isLoading: false,
      fullPage: true,
      checkList: [],
      perPage: 10,
      checked: false,
      selectedCheckList: [],
      claimNotifications: [],
      activeNotification: "",
      costScheduleLink: "",
      technicalReportLink: "",
      exploreFileLink: "",
      industryType: 0,
      industryTypeOptions: [
        { label: "NON-SELECTED", code: 0 },
        { label: "TECH", code: 1 },
        { label: "MEDICAL", code: 2 },
        { label: "INDUSTRIAL", code: 3 },
      ],
      emailString: "",
      proxyVal: "",
    };
  },
  props: ["client_id", "claim_id"],
  watch: {
    checkList(newVal, oldVal) {
      this.$refs.vuetableChecklist.refresh();
    },
    documetList(newVal, oldVal) {
      this.$refs.vuetableClientChecklist.refresh();
    },
    claim_id: function (newVal, oldVal) {
      this.refreshDocumentList();
      this.getClientClaimsNotifications();
    },
    claimNotifications: function (newVal, oldVal) {
      this.$refs.vuetableClientNotification.refresh();
    },
    activeClaim: function (newVal, oldVal) {
      if (this.activeClaim) {
        this.industryType = this.activeClaim.industryType;
        this.proxyVal = this.proxyString(this.activeClaim);
        this.tr_upadte_str = this.updateByTrStr(
          this.activeClaim.trUpdateBy,
          this.activeClaim.trUpdatedOn
        );
        this.cs_upadte_str = this.updateByCsStr(
          this.activeClaim.csUpdateBy,
          this.activeClaim.csUpdatedOn
        );
      }
    },
  },
  methods: {
    ...mapActions("admin", [
      "loadCheckList",
      "getAllClaimDocuments",
      "submitClaimDocuments",
      "rejectClaimDocuments",
      "getClaimsNotifications",
      "getCostSheetLink",
      "getTechnicalReportLink",
      "getExploreFileLink",
      "changeIndustryType",
      "getClaimRecordById",
      "sendDocumentAddEmail",
      "proxyConstSheetInject",
    ]),
    disableClass() {
      if (this.proxyVal != 0) {
        return "disable-checkbox";
      }
    },
    proxyDisableCheck() {
      if (
        this.proxyVal != 0 ||
        !this.checkIfClaimHasPermission(this.activeClaim)
      ) {
        return true;
      }
    },
    proxySelected(type) {
      this.proxyConstSheetInjection(type);
    },
    proxyConstSheetInjection(type) {
      this.isLoading = true;
      let claimParams = {
        claimId: this.claim_id,
        proxy: type,
      };
      this.proxyConstSheetInject(claimParams).then((data) => {
        if (data.data && data.data.success && data.data.success.message) {
          this.$root.$emit('documents-updated');
          if (type == "PROXY") {
            this.activeClaim.proxy = 1;
          } else if (type == "NON_PROXY") {
            this.activeClaim.proxy = 2;
          }
          this.$snotify
            .success(data.data && data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
        } else {
          this.proxyVal = "";
        }
        this.isLoading = false;
      });
    },
    sendDocumentEmail() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      this.sendDocumentAddEmail(claimParams).then((data) => {
        if (data.data && data.data.success && data.data.success.message) {
          this.$snotify
            .success(data.data && data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {
              this.closeEmailConfirmBox();
            });
        }
        this.isLoading = false;
      });
    },
    refreshClaimSpecificData() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      if (this.claim_id) {
        this.getClaimRecordById(claimParams).then((data) => {
          if (data && data.data) {
            this.cs_upadte_str = this.updateByCsStr(
              data.data.csUpdateBy,
              data.data.csUpdatedOn
            );
            this.tr_upadte_str = this.updateByTrStr(
              data.data.trUpdateBy,
              data.data.trUpdatedOn
            );
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    costScheduleView() {
      this.costScheduleLink = "";
      this.isLoading = true;
      let claimdata = {
        claim_id: this.claim_id,
      };
      this.getCostSheetLink(claimdata).then((data) => {
        if (data.data.errors) {
          this.$snotify
            .error("Cost sheet data issue - Document Not Found", "Error!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
        } else {
          if (
            data.data &&
            data.data.message &&
            this.validSharePointURL(data.data.message)
          ) {
            //window.open(data.data.message);
            this.costScheduleLink = data.data.message;
            this.$bvModal.show("modal-cost-schedule");
          } else {
            this.$snotify
              .error("Cost sheet validation issue - Document Not Found", "Error!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
          }
        }
        this.isLoading = false;
      });
    },
    viewExploreFileLink() {
      this.exploreFileLink = "";
      this.isLoading = true;
      let claimdata = {
        claim_id: this.claim_id,
      };
      this.getExploreFileLink(claimdata).then((data) => {
        if (data.data.errors) {
          this.$snotify
            .error("Summary view file data issue - Document Not Found", "Error!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
        } else {
          if (
            data.data &&
            data.data.message &&
            this.validSharePointURL(data.data.message)
          ) {
            //window.open(data.data.message);
            this.exploreFileLink = data.data.message;
            this.$bvModal.show("modal-explore-file");
          } else {
            this.$snotify
              .error("Summary explore file validation issue - Document Not Found", "Error!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
          }
        }
        this.isLoading = false;
      });
    },
    technicalReportView() {
      this.technicalReportLink = "";
      this.isLoading = true;
      let claimdata = {
        claim_id: this.claim_id,
      };
      this.getTechnicalReportLink(claimdata).then((data) => {
        if (data.data.errors) {
          this.$snotify
            .error("Technical Report data issue - Document Not Found", "Error!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
        } else {
          if (
            data.data &&
            data.data.message &&
            this.validSharePointURL(data.data.message)
          ) {
            //window.open(data.data.message);
            this.technicalReportLink = data.data.message;
            this.$bvModal.show("modal-technical-report");
          } else {
            this.$snotify
              .error("Technical report validation issue - Document Not Found", "Error!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
          }
        }
        this.isLoading = false;
      });
    },
    setActiveDescriotion(activeNotification) {
      this.activeNotification = activeNotification;
    },
    getClientClaimsNotifications() {
      this.isLoading = true;
      if (this.claim_id) {
        let claimdata = {
          claim_id: this.claim_id,
        };
        this.getClaimsNotifications(claimdata).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data.data) {
              this.claimNotifications = data.data.data;
            } else {
              this.claimNotifications = [];
            }
          }
          this.isLoading = false;
        });
      } else {
        this.claimNotifications = [];
        this.isLoading = false;
      }
    },
    refreshDocumentList() {
      this.isLoading = true;
      this.documetList = [];
      if (this.claim_id) {
        const userdata = {
          claim_id: this.claim_id,
        };
        this.getAllClaimDocuments(userdata).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data) {
              this.documetList = data.data;
            }
          }
          this.isLoading = false;
        });
      } else {
        this.documetList = [];
        this.isLoading = false;
      }
    },
    rejectClaimDocumentByAnalyst(id, isSwitchOn) {
      if (!isSwitchOn) {
        this.isLoading = true;
        const param = {
          claimDocId: id,
        };
        this.rejectClaimDocuments(param).then((data) => {
          if (data.data.success.status) {
            this.getClientClaimsNotifications();
            this.$bvModal.hide("bv-modal-example");
            this.$snotify
              .success(data.data.success.data, "Success!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
          }
          this.isLoading = false;
        });
      }
    },
    closeEmailConfirmBox() {
      this.$bvModal.hide("email-send-confirmation");
    },
    addClaimDocuments() {
      this.isLoading = true;
      const param = {
        body_data: this.selectedCheckList,
        claim_id: this.claim_id,
      };

      this.submitClaimDocuments(param).then((data) => {
        if (data.data.errors) {
        } else {
          this.refreshDocumentList();
          this.getClientClaimsNotifications();
          this.$bvModal.hide("bv-modal-1");
          if (data.data && data.data.success && data.data.success.message) {
            this.$snotify
              .success(data.data && data.data.success.message, "Success!", {
                position: "centerTop",
              })
              .on("destroyed", () => {
                let emails = data.data.success.data;
                if (emails.length) {
                  this.emailString = emails.join(";");
                }
                this.$bvModal.show("email-send-confirmation");
              });
          }
        }
        this.isLoading = false;
      });
    },
    onChangePageCheckList(page) {
      this.$refs.vuetableChecklist.changePage(page);
    },
    onChangePageClientCheckList(page) {
      this.$refs.vuetableClientChecklist.changePage(page);
    },
    onChangePageClientNotification(page) {
      this.$refs.vuetableClientNotification.changePage(page);
    },
    onPaginationDataCheckList(paginationData) {
      this.$refs.paginationCheckList.setPaginationData(paginationData);
      this.$refs.paginationInfoCheckList.setPaginationData(paginationData);
    },
    onPaginationDataClientCheckList(paginationData) {
      this.$refs.paginationClientCheckList.setPaginationData(paginationData);
      this.$refs.paginationClientInfoCheckList.setPaginationData(
        paginationData
      );
    },
    onPaginationDataNotification(paginationData) {
      this.$refs.paginationNotification.setPaginationData(paginationData);
      this.$refs.paginationInfoNotification.setPaginationData(paginationData);
    },
    loadCheckListInitial() {
      this.selectedCheckList = [];
      let params = {};
      this.loadCheckList(params).then((data) => {
        if (data.data.errors) {
        } else {
          this.checkList = data.data;
        }
      });
    },
    dataManagerChecklist(sortOrder, pagination) {
      let local = this.checkList;
      let filtered = this.checkList.filter((chkl) => {
        let docExist = this.documetList.filter((doclst) => {
          if (doclst.documentType && chkl.id == doclst.documentType.id) {
            return true;
          }
        });
        if (docExist.length) {
          chkl.exsting = true;
          this.selectedCheckList.push(chkl.id);
        } else {
          chkl.exsting = false;
        }
        return true;
      });
      if (sortOrder.length > 0) {
        filtered = _.orderBy(
          filtered,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableChecklist.makePagination(
        filtered.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(filtered, from, to),
      };
    },
    dataManagerClientCheckList(sortOrder, pagination) {
      let local = this.documetList;
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }
      pagination = this.$refs.vuetableClientChecklist.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    dataManagerClientNotification(sortOrder, pagination) {
      let local = this.claimNotifications;

      /* loadash filter array from id */
      let filtered = _.sortBy(this.claimNotifications, function (obj) {
        return obj.id;
      });
      local = filtered.reverse();

      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableClientNotification.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    industryTypeDisableCheck() {
      let disable = false;
      if (
        this.industryType != 0 ||
        !this.checkIfClaimHasPermission(this.activeClaim)
      ) {
        disable = "disabled";
      }
      return disable;
    },
    changeIndustry() {
      this.isLoading = true;
      let param = {
        claimId: this.claim_id,
        industry: this.getIndustryTypeString(this.industryType),
      };
      this.changeIndustryType(param).then((data) => {
        if (data.data.errors) {
        } else {
          if (data.data && data.data.success && data.data.success.message) {
            this.$root.$emit('documents-updated');

            this.activeClaim.industryType = this.industryType;
            this.$snotify
              .success(
                data.data && data.data.success && data.data.success.message,
                "Success!",
                {
                  position: "centerTop",
                }
              )
              .on("destroyed", () => {
                this.refreshClaimSpecificData();
              });
          }
        }
        this.isLoading = false;
      });
    },
    getIndustryTypeStr() {
      if (this.activeClaim && this.industryType) {
        return this.getIndustryTypeString(this.industryType);
      } else {
        return "?";
      }
    },
  },
  computed: {
    editCheckListDisableCondition() {
      let disableCheck = false;
      if (
        !this.claim_id ||
        !this.client_id ||
        (this.activeClaim && this.activeClaim.internalReviewStatus == 5)
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },
    tr_upadte_str: {
      get() {
        return this.$store.state.admin.tr_upadte_str;
      },
      set(val) {
        this.$store.state.admin.tr_upadte_str = val;
      },
    },
    cs_upadte_str: {
      get() {
        return this.$store.state.admin.cs_upadte_str;
      },
      set(val) {
        this.$store.state.admin.cs_upadte_str = val;
      },
    },
    client: {
      get() {
        return this.$store.state.client;
      },
      set(val) {
        this.$store.state.client = val;
      },
    },
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(val) {
        this.$store.state.client_name = val;
      },
    },
    documetList: {
      get() {
        return this.$store.state.documetList;
      },
      set(val) {
        this.$store.state.documetList = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
  },
};
</script>

<style scoped>
.disable-checkbox {
  pointer-events: none;
}
.text-wrap-div {
  word-break: break-word;
}
.industry-str {
  font-size: 11px;
}
.custom-non-br-undeline {
  border-bottom: 1px;
  border-bottom-style: solid;
}
.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.color-block {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: 5px;
  float: right;
  min-height: 12px;
  min-width: 12px;
  max-height: 12px;
  max-width: 12px;
}

.notification-color {
  background-color: #921210;
  padding: 10px;
  margin-top: -21px;
  margin-bottom: 10px;
  margin-left: -21px;
  margin-right: -21px;
  border-radius: 4px 4px 0px 0px;
}

.checklist-color {
  background-color: #ca9c24;
  padding: 10px;
  margin-top: -21px;
  margin-bottom: 10px;
  margin-left: -21px;
  margin-right: -21px;
  border-radius: 4px 4px 0px 0px;
}
</style>
